<template>
  <form @submit.prevent="onSubmitInternal">
    <!-- Senha atual -->
    <div class="mb-3">
    <label class="form-label">Senha atual</label>
    <div class="input-with-icon">
        <input
        :type="showCurrent ? 'text' : 'password'"
        class="form-control pe-5"
        v-model="form.currentPassword"
        required
        autocomplete="current-password"
        />
        <button
        type="button"
        class="toggle-visibility"
        :aria-pressed="showCurrent ? 'true' : 'false'"
        :title="showCurrent ? 'Ocultar senha' : 'Mostrar senha'"
        @click="showCurrent = !showCurrent"
        >
        <i :class="showCurrent ? 'bi bi-eye-slash-fill' : 'bi bi-eye-fill'"></i>
        </button>
    </div>
    <small class="text-danger" v-if="errorsComputed.currentPassword">{{ errorsComputed.currentPassword }}</small>
    </div>

    <!-- Nova senha -->
    <div class="mb-3">
    <label class="form-label">Nova senha</label>
    <div class="input-with-icon">
        <input
        :type="showNew ? 'text' : 'password'"
        class="form-control pe-5"
        v-model="form.newPassword"
        required
        autocomplete="new-password"
        />
        <button
        type="button"
        class="toggle-visibility"
        :aria-pressed="showNew ? 'true' : 'false'"
        :title="showNew ? 'Ocultar senha' : 'Mostrar senha'"
        @click="showNew = !showNew"
        >
        <i :class="showNew ? 'bi bi-eye-slash-fill' : 'bi bi-eye-fill'"></i>
        </button>
    </div>
    <!-- <small class="text-muted d-block mt-1">Use ao menos 8 caracteres.</small> -->
    <small class="text-danger" v-if="errorsComputed.newPassword">{{ errorsComputed.newPassword }}</small>
    </div>

    <!-- Confirmar nova senha -->
    <div class="mb-3">
    <label class="form-label">Confirmar nova senha</label>
    <div class="input-with-icon">
        <input
        :type="showConfirm ? 'text' : 'password'"
        class="form-control pe-5"
        v-model="form.confirmPassword"
        required
        autocomplete="new-password"
        />
        <button
        type="button"
        class="toggle-visibility"
        :aria-pressed="showConfirm ? 'true' : 'false'"
        :title="showConfirm ? 'Ocultar senha' : 'Mostrar senha'"
        @click="showConfirm = !showConfirm"
        >
        <i :class="showConfirm ? 'bi bi-eye-slash-fill' : 'bi bi-eye-fill'"></i>
        </button>
    </div>
    <small class="text-danger" v-if="errorsComputed.confirmPassword">{{ errorsComputed.confirmPassword }}</small>
    </div>

    <div class="form-check mb-3">
      <input class="form-check-input" type="checkbox" id="logoutOthers" v-model="form.logoutOthers">
      <label class="form-check-label" for="logoutOthers">Encerrar sessão em outros dispositivos</label>
    </div>

    <div class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-secondary me-2" @click="$emit('cancel')" :disabled="loading">Cancelar</button>
      <button type="submit" class="btn btn-primary" :disabled="loading || !isValid">
        <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
        Salvar
      </button>
    </div>

    <div v-if="serverError" class="alert alert-danger mt-3">{{ serverError }}</div>
    <div v-if="serverSuccess" class="alert alert-success mt-3">{{ serverSuccess }}</div>
  </form>
</template>

<script>
import { changePassword } from '@/services/account';

export default {
  name: 'AlterarSenhaForm',
  emits: ['success', 'cancel'],
  data() {
    return {
      form: { currentPassword: '', newPassword: '', confirmPassword: '', logoutOthers: true },
      serverError: '',
      serverSuccess: '',
      loading: false,
      showCurrent: false,
      showNew: false,
      showConfirm: false,
    };
  },
  computed: {
    errorsComputed() {
      const e = {};
      if (!this.form.currentPassword) e.currentPassword = 'Informe a senha atual.';
      if (!this.form.newPassword || this.form.newPassword.length < 8) e.newPassword = 'A nova senha deve ter ao menos 8 caracteres.';
      if (this.form.confirmPassword !== this.form.newPassword) e.confirmPassword = 'As senhas não conferem.';
      return e;
    },
    isValid() {
      return Object.keys(this.errorsComputed).length === 0;
    },
  },
  methods: {
    async onSubmitInternal() {
      this.serverError = '';
      this.serverSuccess = '';
      if (!this.isValid) return;
      this.loading = true;
      try {
        const { currentPassword, newPassword, logoutOthers } = this.form;
        const resp = await changePassword({ currentPassword, newPassword, logoutOthers });
        this.serverSuccess = resp?.message || 'Senha alterada com sucesso.';
        this.$emit('success');
      } catch (err) {
        const msg = err?.response?.data?.message || 'Não foi possível alterar a senha.';
        this.serverError = msg;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.form-label { font-size: 14px; margin-bottom: 5px; }
.form-control { padding: 10px; font-size: 14px; }
.btn.btn-primary { padding: 10px; font-size: 16px; }
.input-with-icon {
  position: relative;
}

.input-with-icon .toggle-visibility {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  border: 0;
  background: transparent;
  padding: 0;
  line-height: 1;
  cursor: pointer;
}

.input-with-icon .toggle-visibility i {
  font-size: 1.1rem;
}

/* garante respiro à direita p/ não sobrepor o ícone */
.form-control.pe-5 { padding-right: 2.5rem !important; }

</style>